import { text } from '#contract'
import { useView } from '../app/use-view.ts'
import { ProgressScreen } from '../components/progress-screen.tsx'
import { useT } from '../i18n/index.ts'

/** Shown while a level loads: its name, the current step and the progress. */
export function LoadingScreen() {
  const t = useT()
  const loading = useView((view) => view.loading)

  return (
    <ProgressScreen
      // The name arrives once the level's definition has loaded.
      title={loading?.levelName ? t(loading.levelName) : ' '}
      status={loading ? t(loading.step) : ''}
      label={t(text('loading.label'))}
      value={loading?.progress ?? 0}
    />
  )
}
